export default consentAAM => ({ consentAAM: consentAAM ? '0' : '1' });
